import { render } from "./InvoicePrint.vue?vue&type=template&id=338a8dd4&scoped=true"
import script from "./InvoicePrint.vue?vue&type=script&lang=js"
export * from "./InvoicePrint.vue?vue&type=script&lang=js"

import "./InvoicePrint.vue?vue&type=style&index=0&id=338a8dd4&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Asistenca\\old-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338a8dd4"]])

export default __exports__